import { actionCreatorFactory } from 'typescript-fsa';
import { INode, INodeListParams } from './node.interface';

export namespace NodeAction {
  const actionCreator = actionCreatorFactory('Node');

  export const loadList = actionCreator.async<INodeListParams, { nodeList: INode[] }, void>('LOAD_LIST');

  export const select = actionCreator<{ nodeId: INode['nodeId'] }>('SELECT');
  export const toggleSelect = actionCreator<{ nodeId: INode['nodeId'] }>('TOGGLE_SELECT');
  export const clearSelect = actionCreator('CLEAR_SELECT');

  export const remove = actionCreator.async<{ nodeId: INode['nodeId'] }, { nodeId: INode['nodeId'] }, void>('REMOVE');

  export const destroy = actionCreator('DESTROY');
}
